import * as Yup from 'yup';
import moment from 'moment';

export const schema = Yup.object().shape({
  motive: Yup.string().required(),
  creation_date: Yup.string().required(),
  active: Yup.boolean().required()
});

export const formInitialState = {
  motive: '',
  creation_date: moment(new Date()).format('YYYY-MM-DD'),
  active: false
};

export const formErrorInitialState = {
  motiveError: false,
  creation_dateError: false,
  activeError: false
};
